import { createApp } from 'vue'
import App from './App.vue'
import { app as appInfo } from '@shared/lib/app'
import { startLongTaskObserver } from './lib/perf'
import { loadSession } from './lib/session'
import { staffHome } from './lib/staffLogin'
import './styles.css'

// Only active with ?perf=1; otherwise returns null and registers nothing.
startLongTaskObserver()

// /admin and /pengawas have their own entries (admin.html, pengawas.html); this one is the student
// app only and must not pull in Quasar.
document.title = appInfo.name
// A signed-in participant resumes in App; a signed-in staff member goes to their own screen.
const home = loadSession() ? null : staffHome()
if (home) window.location.replace(home)
else createApp(App).mount('#app')
